import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import "@/assets/css/compat.css";
import "@/assets/css/custom.css";
import { VueMaskDirective } from "v-mask";

import dayjs from "./plugins/dayjs";

Vue.use({
  install: function (Vue) {
    Vue.prototype.$dayjs = dayjs;
  },
});

Vue.filter("currency", function (value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const num = Number(value);
  if (isNaN(num)) {
    return value;
  }

  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
});
Vue.directive("mask", VueMaskDirective);

Vue.config.productionTip = false;
window.Moment = dayjs;

Object.defineProperty(Vue.prototype, "ENUMS", { value: window.ENUMS });
Object.defineProperty(Vue.prototype, "Moment", { value: window.Moment });

Vue.filter("str_limit", function (value, size) {
  if (!value) return "";
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + "...";
});

Vue.filter("formatDate", function (value) {
  if (value) {
    return dayjs(String(value)).format("MM/DD/YYYY");
  }
});

Vue.filter("formatDateTime", function (value) {
  if (value) {
    return dayjs(String(value)).format("MM/DD/YYYY hh:mm A");
  }
});

Vue.filter("formatDateTime24hours", function (value) {
  if (value) {
    return dayjs(String(value)).format("MM/DD/YYYY HH:mm");
  }
});

Vue.filter("formatMonth", function (value) {
  if (value) {
    return dayjs(String(value)).format("MM-YYYY");
  }
});

Vue.filter("formatMonthSoa", function (value) {
  if (value) {
    return dayjs(String(value)).format("MMM YYYY");
  }
});

Vue.filter("thousandSeprator", function (value) {
  if (value !== "" && value !== undefined && value !== 0 && value !== "0" && value !== null) {
    return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return value;
  }
});

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  return value.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
});

Vue.filter("uppercase", function (value) {
  if (!value) return "";
  return value.toUpperCase();
});

Vue.filter("percentTwoDecimals", function (value, decimal_places = 2) {
  if (!value) {
    value = 0;
  }

  value = value * 100;
  value = Math.round(value * Math.pow(10, decimal_places)) / Math.pow(10, decimal_places);
  value = value + "%";
  return value;
});

Vue.filter("formatDateWithDay", function (value) {
  if (value) {
    return dayjs(String(value)).format("dddd (MMMM D, YYYY)");
  }
});

Vue.filter("formatLongDate", function (value) {
  if (value) {
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  VueMaskDirective,
}).$mount("#app");
